<script lang="ts" setup>
import type { HTMLAttributes } from 'vue'
import { useFormField } from './useFormField'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
const appConfig = useAppConfig()
const { formDescriptionId } = useFormField()
</script>

<template>
  <p
    :id="formDescriptionId"
    :class="cn(appConfig.ui.form.slots.description, props.class)"
  >
    <slot />
  </p>
</template>
